import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";

import { useMobile } from "@krea/customer-features/hooks";
import Check from "@krea/customer-features/images/svg/check-colorless.svg";
import { settings } from "@krea/customer-features/settings";
import { AccordionItem } from "@krea/customer-features/shared-components/accordion/AccordionItem";
import ContactsGoogle from "@krea/customer-features/shared-components/app/contacts/ContactsGoogle";
import ContactsTrustpilot from "@krea/customer-features/shared-components/app/contacts/ContactsTrustpilot";
import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";
import { CountryCode } from "@krea/shared/types/common";

const StyledCheckmarkWithText = ({ text }: { text: string }) => (
  <div className="tw-flex tw-items-center tw-space-x-3 ">
    {/* TODO: Replace with styled checkmark from websites repo when available */}
    <div
      className="tw-flex tw-h-[20px] tw-w-[20px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-primary"
      style={{ backgroundColor: "#FBF2FF" }}
    >
      <SVG className="tw-m-0 tw-p-0 tw-text-primary" src={Check} />
    </div>
    <Text size="sm" className=" tw-m-0 tw-p-0">
      {text}
    </Text>
  </div>
);

export const StartApplicationSection = ({
  handleSubmit,
}: {
  handleSubmit: () => void;
}) => {
  const { t } = useTranslation();
  const isMobile = useMobile();

  const contactSectionPerCountry: Record<CountryCode, ReactNode> = {
    [CountryCode.FI]: <ContactsGoogle className="" isSimpleVersion />,
    [CountryCode.SE]: (
      <div>
        <ContactsTrustpilot className="" isSimpleVersion />
        <ContactsGoogle className="tw-mt-2" isSimpleVersion />
      </div>
    ),
  };

  return (
    <>
      <div className="tw-rounded-xl tw-border tw-border-solid tw-border-primary">
        <div className="tw-rounded-t-xl tw-bg-purple-50 tw-px-5 tw-py-4">
          <Text size="lg" className="tw-font-bold">
            {t("preliminaryBidForm.startApplication")}
          </Text>
        </div>

        {isMobile && (
          <div className="tw-ml-5 tw-mt-5 tw-text-gray-700">
            {contactSectionPerCountry[settings.countryCode]}{" "}
          </div>
        )}

        <div className="tw-px-5 tw-py-4">
          {isMobile ? (
            <AccordionItem
              titleStyling="tw-font-normal tw-text-md"
              title={t("preliminaryBidForm.seeHowItWorks")}
            >
              <div className="tw-space-y-2">
                <StyledCheckmarkWithText
                  text={t("preliminaryBidForm.howItWorksDescription1")}
                />
                <StyledCheckmarkWithText
                  text={t("preliminaryBidForm.howItWorksDescription2")}
                />
                <StyledCheckmarkWithText
                  text={t("preliminaryBidForm.howItWorksDescription3")}
                />
              </div>
            </AccordionItem>
          ) : (
            <div className="tw-space-y-2 tw-py-2">
              <StyledCheckmarkWithText
                text={t("preliminaryBidForm.howItWorksDescription1")}
              />
              <StyledCheckmarkWithText
                text={t("preliminaryBidForm.howItWorksDescription2")}
              />
              <StyledCheckmarkWithText
                text={t("preliminaryBidForm.howItWorksDescription3")}
              />
            </div>
          )}
        </div>

        {!isMobile && (
          <div className="tw-mx-5 tw-mb-4">
            <Button size="lg" className="tw-w-full" onClick={handleSubmit}>
              {t("applicationForm.common.continue")}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
